/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import { getAuthToken } from '../../helpers/request';

interface GuestGuardProps {
  children: React.ReactNode;
}

export default function GuestGuard({
  children,
}: GuestGuardProps): React.ReactElement {
  const navigate = useNavigate();

  useEffect(() => {
    if (getAuthToken()) {
      navigate(ROUTE_PATHS.PORTAL);
    }
  }, []);

  return <>{children}</>;
}
